import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Shield } from 'lucide-react';

const BANNER_PLAIN = "/assets/brand/logo-inline.png";

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Simple Nav */}
      <nav className="fixed top-0 left-0 right-0 z-50 glass-nav">
        <div className="container-wide flex items-center justify-between h-16">
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
            <img src={BANNER_PLAIN} alt="Wrapped In Music" className="h-8 w-auto" />
          </div>
        </div>
      </nav>

      <main className="pt-24 pb-12 px-4 lg:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="flex items-center gap-4 mb-8">
            <Button
              variant="ghost"
              onClick={() => navigate(-1)}
              className="text-zinc-400 hover:text-white"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div>
              <h1 className="text-3xl font-bold text-white flex items-center gap-3">
                <Shield className="h-8 w-8 text-primary" />
                Privacy Policy
              </h1>
            </div>
          </div>

          <div className="glass-card p-8 prose prose-invert max-w-none">
            <p className="text-zinc-400 mb-6">
              <em>Last updated: January 2025</em>
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-zinc-300">
              We collect information you provide directly to us, including your name, email address, and payment information when you create an account or make a purchase. We also collect content you create using our Service.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-zinc-300">
              We use your information to provide, maintain, and improve our Service, process transactions, send you technical notices and support messages, and respond to your inquiries.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Information Sharing</h2>
            <p className="text-zinc-300">
              We do not sell, trade, or rent your personal information to third parties. We may share information with service providers who assist us in operating our Service, subject to confidentiality agreements.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Data Security</h2>
            <p className="text-zinc-300">
              We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Cookies and Tracking</h2>
            <p className="text-zinc-300">
              We use cookies and similar technologies to maintain your session, remember your preferences, and analyze how our Service is used. You can control cookies through your browser settings.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Third-Party Services</h2>
            <p className="text-zinc-300">
              Our Service may integrate with third-party services for payment processing, authentication, and AI features. These services have their own privacy policies governing the use of your information.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Data Retention</h2>
            <p className="text-zinc-300">
              We retain your information for as long as your account is active or as needed to provide you services. You may request deletion of your account and associated data at any time.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Your Rights</h2>
            <p className="text-zinc-300">
              You have the right to access, correct, or delete your personal information. You may also request a copy of your data or object to certain processing activities.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">9. Children's Privacy</h2>
            <p className="text-zinc-300">
              Our Service is not intended for children under 13. We do not knowingly collect personal information from children under 13.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">10. Changes to This Policy</h2>
            <p className="text-zinc-300">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">11. Contact Us</h2>
            <p className="text-zinc-300">
              If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:support@wrappedinmusic.com" className="text-primary hover:underline">
                support@wrappedinmusic.com
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
